import { apiClient } from "../../base/ApiClient";


//  post Dnacpr of document
export const createDnacpr = async (dnacprData) => {
  const response = await apiClient.post(`/client/DNACPR/`, dnacprData);
  return response.data;
};

//    get Dnacpr of document
export const getDnacpr = async (client_id) => {
  const response = await apiClient.get(
    `/client/DNACPR/?client_id=${client_id}`
  );
  return response.data;
};

// delete Dnacpr
export const deleteDnacpr = async (id) => {
  const response = await apiClient.delete(`/client/DNACPR/${id}/`);
  return response.data;
};

// get dnacpr by id for edit
export const getDnacprById = async (id) => {
  const response = await apiClient.get(`/client/DNACPR/${id}/`);
  return response.data;
};

// edit dnacpr
export const updateDnacpr = async (id, editData) => {
  const response = await apiClient.put(`/client/DNACPR/${id}/`,editData);
  return response.data;
};

//  post LPA of document
export const createLPA = async (lpaData) => {
  const response = await apiClient.post(`/client/LPA/`, lpaData);
  return response.data;
};

//    get Lpa of document
export const getLpa = async (client_id) => {
  const response = await apiClient.get(`/client/LPA/?client_id=${client_id}`);
  return response.data;
};

// delete Lpa
export const deleteLpa = async (id) => {
  const response = await apiClient.delete(`/client/LPA/${id}/`);
  return response.data;
};

// get Lpa by id for edit
export const getLpaById = async (id) => {
  const response = await apiClient.get(`/client/LPA/${id}/`);
  return response.data;
};

// edit Lpa
export const updateLpa = async (id, editData) => {
  const response = await apiClient.put(`/client/LPA/${id}/`,editData);
  return response.data;
};

//  post Dols of document
export const createDols = async (dolsData) => {
  const response = await apiClient.post(`/client/documents/`, dolsData);
  return response.data;
};

//    get Dols of document
export const getDols = async (client_id) => {
  const response = await apiClient.get(`/client/documents/?client_id=${client_id}`);
  return response.data;
};

// delete Dols
export const deleteDols = async (id) => {
  const response = await apiClient.delete(`/client/documents/${id}/`);
  return response.data;
};

// get Dols by id for edit
export const getDolsById = async (id) => {
  const response = await apiClient.get(`/client/documents/${id}/`);
  return response.data;
};

// edit Dols
export const updateDols = async (id, editData) => {
  const response = await apiClient.patch(`/client/documents/${id}/`,editData);
  return response.data;
};
